{
  "billing.nav": "الفواتير",
  "billing.subtitle": "العروض والفواتير المبدئية وطلبات الدفع، وما دفعه العملاء وما ننفقه.",
  "billing.quotes.subtitle": "عروض تُبنى في 404 OS أو تُرفق كملف.",
  "billing.invoices.subtitle": "الفواتير المبدئية وطلبات الدفع، وما يزال مستحقاً.",
  "billing.payments.subtitle": "التحويلات المسجّلة على مستندات صادرة.",
  "billing.expenses.subtitle": "ما تنفقه الوكالة، حسب الفئة والمشروع.",
  "billing.overdueCount": "{count, plural, zero {لا متأخرات} one {مستند متأخر} two {مستندان متأخران} few {# مستندات متأخرة} many {# مستنداً متأخراً} other {# مستند متأخر}}",
  "billing.loadError": "تعذّر تحميل الفواتير.",
  "billing.newQuote": "عرض جديد",
  "billing.newRequest": "طلب دفع جديد",
  "billing.newProforma": "فاتورة مبدئية جديدة",
  "billing.reports.nav": "التقارير",
  "billing.side.label": "تفاصيل الفواتير",
  "billing.readOnly": "يمكنك متابعة الفواتير هنا؛ يُصدر فريق المالية المستندات ويسجّل المدفوعات.",
  "billing.kpi.outstanding": "المستحق",
  "billing.kpi.overdue": "متأخر السداد",
  "billing.kpi.collected": "المحصّل هذا الشهر",
  "billing.kpi.credit": "أرصدة العملاء",
  "billing.kpi.none": "لا شيء",
  "billing.kpi.label": "الأموال في لمحة",
  "billing.kpi.documents": "{count, plural, zero {لا مستندات} one {مستند واحد} two {مستندان} few {# مستندات} many {# مستنداً} other {# مستند}}",
  "billing.tabs.label": "مستندات الفواتير",
  "billing.tab.quotes": "العروض",
  "billing.tab.invoices": "الفواتير",
  "billing.tab.payments": "المدفوعات",
  "billing.filter.label": "تصفية حسب الحالة",
  "billing.search": "ابحث بالرقم أو العنوان أو العميل",
  "billing.filter.all": "الكل",
  "billing.filter.open": "مفتوحة",
  "billing.filter.overdue": "متأخرة",
  "billing.filter.draft": "مسودات",
  "billing.filter.paid": "مدفوعة",
  "billing.filter.void": "ملغاة",
  "billing.filter.sent": "بانتظار الرد",
  "billing.filter.accepted": "مقبولة",
  "billing.filter.declined": "مرفوضة",
  "billing.filter.expired": "منتهية",
  "billing.quoteStatus.draft": "مسودة",
  "billing.quoteStatus.sent": "مُرسل",
  "billing.quoteStatus.accepted": "مقبول",
  "billing.quoteStatus.declined": "مرفوض",
  "billing.quoteStatus.expired": "منتهي",
  "billing.invoiceStatus.draft": "مسودة",
  "billing.invoiceStatus.issued": "صادرة",
  "billing.invoiceStatus.partially_paid": "مدفوعة جزئياً",
  "billing.invoiceStatus.paid": "مدفوعة",
  "billing.invoiceStatus.void": "ملغاة",
  "billing.overdue": "متأخرة",
  "billing.kind.proforma": "فاتورة مبدئية",
  "billing.kind.payment_request": "طلب دفع",
  "billing.method.instapay": "إنستاباي",
  "billing.method.vodafone_cash": "فودافون كاش",
  "billing.method.bank_transfer": "تحويل بنكي",
  "billing.method.cash": "نقداً",
  "billing.method.client_credit": "من رصيد العميل",
  "billing.col.number": "الرقم",
  "billing.col.document": "المستند",
  "billing.col.client": "العميل",
  "billing.col.status": "الحالة",
  "billing.col.validUntil": "صالح حتى",
  "billing.col.due": "الاستحقاق",
  "billing.col.total": "الإجمالي",
  "billing.col.outstanding": "المتبقي",
  "billing.col.date": "التاريخ",
  "billing.col.method": "الطريقة",
  "billing.col.amount": "المبلغ",
  "billing.col.reference": "المرجع",
  "billing.draftNumber": "مسودة",
  "billing.empty.quotes.title": "لا توجد عروض بعد",
  "billing.empty.quotes.body": "اكتب عرضًا وأرسله كرابط، ويقبله العميل عبر الإنترنت.",
  "billing.empty.invoices.title": "لا توجد فواتير بعد",
  "billing.empty.invoices.body": "تظهر هنا الفواتير المبدئية وطلبات الدفع بمجرد إنشائها.",
  "billing.empty.payments.title": "لا توجد مدفوعات بعد",
  "billing.empty.payments.body": "سجّل تحويلات إنستاباي وفودافون كاش والتحويلات البنكية على مستند صادر.",
  "billing.noResults.title": "لا توجد نتائج مطابقة",
  "billing.noResults.body": "جرّب حالة أخرى أو بحثاً آخر.",
  "billing.noResults.clear": "مسح التصفية",
  "billing.proof.open": "فتح إثبات التحويل",
  "billing.proof.upload": "إرفاق إثبات",
  "billing.proof.attached": "تم إرفاق الإثبات",
  "billing.proof.none": "بدون إثبات",
  "billing.quote.new": "عرض جديد",
  "billing.quote.edit": "تعديل العرض",
  "billing.invoice.new.proforma": "فاتورة مبدئية جديدة",
  "billing.invoice.new.payment_request": "طلب دفع جديد",
  "billing.invoice.edit": "تعديل المسودة",
  "billing.field.client": "العميل",
  "billing.field.clientPlaceholder": "اختر عميلاً",
  "billing.field.clientSearch": "ابحث عن عميل",
  "billing.field.clientEmpty": "لا يوجد عميل مطابق",
  "billing.field.project": "المشروع",
  "billing.field.projectPlaceholder": "بدون مشروع",
  "billing.field.projectSearch": "ابحث عن مشروع",
  "billing.field.projectEmpty": "لا يوجد مشروع مطابق",
  "billing.field.title": "العنوان",
  "billing.field.titlePlaceholder": "متجر إلكتروني، المرحلة الثانية",
  "billing.field.language": "لغة المستند",
  "billing.language.ar": "العربية",
  "billing.language.en": "الإنجليزية",
  "billing.field.currency": "العملة",
  "billing.field.tax": "الضريبة",
  "billing.field.validUntil": "صالح حتى",
  "billing.field.dueOn": "تاريخ الاستحقاق",
  "billing.field.dueOnHint": "اتركه فارغاً ليكون بعد ١٤ يوماً من الإصدار.",
  "billing.field.kind": "المستند",
  "billing.field.notes": "ملاحظات",
  "billing.field.terms": "الشروط",
  "billing.field.required": "مطلوب",
  "billing.field.titleMissing": "اكتب عنواناً للمستند.",
  "billing.field.clientMissing": "اختر العميل.",
  "billing.section.parties": "العميل والمشروع",
  "billing.section.lines": "البنود",
  "billing.section.plan": "خطة الدفع",
  "billing.section.notes": "الملاحظات والشروط",
  "billing.section.totals": "الإجماليات",
  "billing.line.description": "الوصف",
  "billing.line.service": "الخدمة",
  "billing.line.noService": "بدون خدمة",
  "billing.line.quantity": "الكمية",
  "billing.line.price": "سعر الوحدة",
  "billing.line.discount": "الخصم ٪",
  "billing.line.taxable": "ضريبة",
  "billing.line.amount": "المبلغ",
  "billing.line.add": "إضافة بند",
  "billing.line.remove": "حذف البند {number}",
  "billing.line.label": "البند {number}",
  "billing.line.empty": "أضف البند الأول: ما يدفع العميل مقابله.",
  "billing.line.invalid": "راجع الكمية والسعر والخصم.",
  "billing.line.missing": "أضف بنداً واحداً على الأقل.",
  "billing.plan.hint": "قسّم الدفع إلى دفعة مقدمة ومراحل وتواريخ. بدون خطة يدفع العميل كامل المبلغ عند القبول.",
  "billing.plan.label": "الدفعة",
  "billing.plan.percent": "النسبة ٪",
  "billing.plan.trigger": "الموعد",
  "billing.plan.dueOn": "التاريخ",
  "billing.trigger.on_acceptance": "عند القبول",
  "billing.trigger.on_milestone": "عند مرحلة",
  "billing.trigger.on_date": "في تاريخ",
  "billing.plan.add": "إضافة دفعة",
  "billing.plan.remove": "حذف الدفعة {number}",
  "billing.plan.sum": "المجموع {percent}",
  "billing.plan.unbalanced": "يجب أن يكون مجموع الدفعات ١٠٠٪ بالضبط.",
  "billing.plan.deposit": "دفعة مقدمة",
  "billing.plan.balance": "باقي المبلغ",
  "billing.plan.dateMissing": "اختر التاريخ.",
  "billing.totals.subtotal": "المجموع الفرعي",
  "billing.totals.discount": "الخصم",
  "billing.totals.tax": "ضريبة القيمة المضافة {percent}",
  "billing.totals.noTax": "بدون ضريبة",
  "billing.totals.total": "الإجمالي",
  "billing.totals.paid": "المدفوع",
  "billing.totals.credited": "إشعارات دائنة",
  "billing.totals.outstanding": "المتبقي للسداد",
  "billing.action.saveDraft": "حفظ المسودة",
  "billing.action.saved": "تم حفظ المسودة",
  "billing.action.send": "إرسال العرض",
  "billing.action.sent": "تم إرسال العرض {number}",
  "billing.send.title": "إرسال العرض؟",
  "billing.send.description": "سيحصل على رقمه. بعد ذلك لا يمكن تعديله؛ انسخه لعمل نسخة جديدة.",
  "billing.action.issue": "إصدار",
  "billing.issue.title": "إصدار هذا المستند؟",
  "billing.issue.description": "سيحصل على الرقم التالي في سلسلته ولن يمكن تعديله بعد ذلك. تُصحَّح الأخطاء بإشعار دائن.",
  "billing.issue.done": "تم إصدار {number}",
  "billing.action.delete": "حذف المسودة",
  "billing.delete.title": "حذف هذه المسودة؟",
  "billing.delete.description": "المسودات بلا رقم بعد، فلا يُفقد شيء من التسلسل.",
  "billing.delete.done": "تم حذف المسودة",
  "billing.action.print": "تنزيل PDF",
  "billing.action.duplicate": "نسخ",
  "billing.duplicate.done": "تم إنشاء نسخة كمسودة",
  "billing.action.whatsapp": "مشاركة عبر واتساب",
  "billing.action.record": "تسجيل دفعة",
  "billing.action.creditNote": "إصدار إشعار دائن",
  "billing.action.void": "إلغاء المستند",
  "billing.action.applyCredit": "استخدام رصيد العميل",
  "billing.action.decline": "تسجيل الرفض",
  "billing.action.startProject": "بدء المشروع",
  "billing.action.proforma": "فاتورة مبدئية بكامل العرض",
  "billing.action.raise": "إنشاء طلب دفع",
  "billing.action.more": "إجراءات أخرى",
  "billing.action.openClientPage": "فتح صفحة العميل",
  "billing.action.back": "الفواتير",
  "billing.action.edit": "تعديل",
  "billing.share.title": "المشاركة مع العميل",
  "billing.share.hint": "يفتح العميل هذا الرابط ويقرأ العرض ويقبله دون حساب.",
  "billing.share.link": "الرابط العام",
  "billing.whatsapp.quote": "مرحباً {name}، هذا عرضنا {number} لـ«{title}»: {total}. يمكنك مراجعته وقبوله من هنا: {link}",
  "billing.whatsapp.invoice": "مرحباً {name}، هذا {title} ({number}): {total}، يستحق في {date}. يمكنك الدفع عبر إنستاباي أو فودافون كاش أو التحويل البنكي. شكراً لك!",
  "billing.timeline.title": "السجل",
  "billing.timeline.created": "أُنشئ",
  "billing.timeline.sent": "أُرسل إلى العميل",
  "billing.timeline.accepted": "قبله {name}",
  "billing.timeline.acceptedFrom": "{email} · من {ip}",
  "billing.timeline.declined": "رُفض",
  "billing.timeline.issued": "صدر",
  "billing.timeline.waiting": "بانتظار العميل",
  "billing.planCard.title": "خطة الدفع",
  "billing.planCard.hint": "أنشئ طلب دفع لكل دفعة عند استحقاقها.",
  "billing.project.title": "المشروع",
  "billing.project.none": "لا يوجد مشروع بعد. بدءه من العرض المقبول يُنشئ أيضاً مرحلة لكل دفعة مرتبطة بمرحلة.",
  "billing.project.open": "فتح المشروع",
  "billing.startProject.title": "بدء المشروع",
  "billing.startProject.description": "يأخذ المشروع عميل هذا العرض وعنوانه.",
  "billing.startProject.key": "الرمز",
  "billing.startProject.keyHint": "من حرفين إلى عشرة حروف أو أرقام تبدأ بحرف، مثل NOON.",
  "billing.startProject.keyInvalid": "استخدم من حرفين إلى عشرة حروف أو أرقام تبدأ بحرف.",
  "billing.startProject.service": "الخدمة",
  "billing.startProject.done": "بدأ المشروع {key}",
  "billing.decline.title": "تسجيل قرار العميل",
  "billing.decline.description": "يُسجَّل العرض كمرفوض ويبقى رقمه مستخدماً.",
  "billing.decline.reason": "السبب (اختياري)",
  "billing.decline.done": "تم تسجيل رفض العرض",
  "billing.frozenQuote": "العروض المُرسلة مجمّدة. انسخ هذا العرض لتغيير أي شيء.",
  "billing.balance.title": "الرصيد",
  "billing.balance.settled": "مسدد بالكامل",
  "billing.payments.title": "المدفوعات",
  "billing.payments.none": "لا مدفوعات بعد.",
  "billing.payments.excess": "تحوّل {amount} إلى رصيد للعميل",
  "billing.credits.title": "الإشعارات الدائنة",
  "billing.credits.kind.correction": "تصحيح",
  "billing.credits.kind.overpayment": "دفعة زائدة",
  "billing.credits.remaining": "المتبقي {amount}",
  "billing.availableCredit": "للعميل رصيد قدره {amount} بهذه العملة.",
  "billing.notTaxInvoice": "ليست فاتورة ضريبية. تصدر الفاتورة الضريبية الرسمية عبر منظومة الفاتورة الإلكترونية لمصلحة الضرائب المصرية.",
  "billing.fromQuote": "من العرض {number}",
  "billing.payment.title": "تسجيل دفعة",
  "billing.payment.description": "على {number}. أي مبلغ يزيد على المتبقي يصبح رصيداً للعميل.",
  "billing.payment.method": "طريقة الدفع",
  "billing.payment.amount": "المبلغ المستلم ({code})",
  "billing.payment.receivedOn": "تاريخ الاستلام",
  "billing.payment.reference": "المرجع",
  "billing.payment.referenceHint": "رقم التحويل أو العملية.",
  "billing.payment.note": "ملاحظة",
  "billing.payment.proof": "إثبات التحويل (اختياري)",
  "billing.payment.proofHint": "PDF أو PNG أو JPEG أو WebP بحد أقصى ١٠ ميجابايت.",
  "billing.payment.settles": "يسدد {amount}",
  "billing.payment.credit": "{amount} يصبح رصيداً للعميل",
  "billing.payment.full": "يسدد المتبقي بالكامل",
  "billing.payment.remaining": "سيتبقى {amount}",
  "billing.payment.egpOnly": "إنستاباي وفودافون كاش بالجنيه المصري فقط.",
  "billing.payment.invalidAmount": "أدخل مبلغاً أكبر من صفر بحد أقصى خانتين عشريتين.",
  "billing.payment.submit": "تسجيل الدفعة",
  "billing.payment.done": "تم تسجيل الدفعة",
  "billing.payment.proofFailed": "سُجّلت الدفعة لكن لم يُرفع الإثبات. أرفقه من الدفعة.",
  "billing.credit.title": "إصدار إشعار دائن",
  "billing.credit.description": "يخفض ما يدين به العميل على {number}، وله رقمه الخاص.",
  "billing.credit.amount": "المبلغ شاملاً الضريبة",
  "billing.credit.reason": "السبب",
  "billing.credit.reasonMissing": "اكتب السبب في كلمات قليلة.",
  "billing.credit.done": "تم إصدار الإشعار الدائن",
  "billing.void.title": "إلغاء هذا المستند؟",
  "billing.void.description": "يُلغى كامل رصيده بإشعار دائن. يبقى الرقم مستخدماً فلا تحدث فجوة في التسلسل.",
  "billing.void.done": "تم إلغاء المستند",
  "billing.applyCredit.title": "استخدام رصيد العميل",
  "billing.applyCredit.description": "سداد جزء من {number} من رصيد العميل البالغ {amount}.",
  "billing.applyCredit.done": "تم استخدام الرصيد",
  "billing.raise.done": "تم إنشاء طلب الدفع كمسودة",
  "billing.proforma.done": "تم إنشاء الفاتورة المبدئية كمسودة",
  "billing.error.QUOTE_EXPIRED": "انتهت صلاحية هذا العرض.",
  "billing.error.QUOTE_ALREADY_DECIDED": "تم قبول هذا العرض أو رفضه بالفعل.",
  "billing.error.QUOTE_ALREADY_BILLED": "هذا العرض مفوتر بالفعل، بفاتورة مبدئية أو بخطته.",
  "billing.error.PLAN_ITEM_ALREADY_BILLED": "لهذه الدفعة طلب دفع بالفعل.",
  "billing.error.DOCUMENT_ISSUED": "لا يمكن تعديل مستند صادر. صححه بإشعار دائن.",
  "billing.error.QUOTE_NOT_DRAFT": "لا يمكن تعديل عرض مُرسل. انسخه بدلاً من ذلك.",
  "billing.error.VERSION_CONFLICT": "غيّر شخص آخر هذا المستند. أعد التحميل وحاول مجدداً.",
  "billing.error.CREDIT_EXCEEDS_BALANCE": "هذا أكثر من الرصيد المفتوح.",
  "billing.error.INSUFFICIENT_CREDIT": "رصيد العميل لا يكفي.",
  "billing.error.INVOICE_HAS_PAYMENTS": "عليه مدفوعات: أصدر إشعاراً دائناً بالمتبقي بدلاً من الإلغاء.",
  "billing.error.METHOD_CURRENCY_MISMATCH": "إنستاباي وفودافون كاش بالجنيه المصري فقط.",
  "billing.error.PLAN_NOT_BALANCED": "يجب أن يكون مجموع خطة الدفع ١٠٠٪.",
  "billing.error.DOCUMENT_EMPTY": "أضف بنداً واحداً على الأقل، أو أرفق ملفاً.",
  "billing.error.FILE_REQUIRED": "أرفق ملف PDF أو صورة أولاً.",
  "billing.error.FILE_NOT_ATTACHED": "لا يوجد ملف مرفق على هذا المستند.",
  "billing.error.CONTRACT_NOT_DRAFT": "لا يمكن تعديل إلا مسودة العقد.",
  "billing.error.CONTRACT_NOT_SENT": "أرسل العقد قبل تعليمه موقّعاً أو مرفوضاً.",
  "billing.error.QUOTE_NOT_FILE_ONLY": "لهذا العرض رابط عام؛ يقبله العميل من هناك.",
  "billing.error.QUOTE_NOT_STRUCTURED": "العرض المرفق كملف لا يُنشئ فواتير.",
  "billing.error.PROJECT_KEY_TAKEN": "يستخدم مشروع آخر هذا الرمز بالفعل.",
  "billing.error.PROOF_TYPE_NOT_ALLOWED": "أرفق ملف PDF أو PNG أو JPEG أو WebP.",
  "billing.error.PROOF_TOO_LARGE": "حجم الملف أكبر من ١٠ ميجابايت.",
  "billing.error.PERMISSION_DENIED": "ليست لديك صلاحية للقيام بذلك.",
  "billing.error.VALIDATION_FAILED": "بعض الحقول تحتاج إلى مراجعة.",
  "billing.doc.quote": "عرض",
  "billing.doc.proforma": "فاتورة مبدئية",
  "billing.doc.payment_request": "طلب دفع",
  "billing.doc.number": "رقم",
  "billing.doc.issued": "التاريخ",
  "billing.doc.validUntil": "صالح حتى",
  "billing.doc.due": "الاستحقاق",
  "billing.doc.billTo": "إلى السادة",
  "billing.doc.description": "الوصف",
  "billing.doc.qty": "الكمية",
  "billing.doc.price": "سعر الوحدة",
  "billing.doc.discount": "الخصم",
  "billing.doc.amount": "المبلغ",
  "billing.doc.subtotal": "المجموع الفرعي",
  "billing.doc.discountTotal": "الخصم",
  "billing.doc.vat": "ضريبة القيمة المضافة",
  "billing.doc.noVat": "بدون ضريبة",
  "billing.doc.total": "الإجمالي",
  "billing.doc.paid": "المدفوع",
  "billing.doc.balance": "المتبقي للسداد",
  "billing.doc.plan": "خطة الدفع",
  "billing.doc.payWith": "طرق الدفع",
  "billing.doc.notes": "ملاحظات",
  "billing.doc.terms": "الشروط",
  "billing.doc.notTax": "هذا المستند ليس فاتورة ضريبية.",
  "billing.doc.taxId": "رقم التسجيل الضريبي",
  "billing.doc.draft": "مسودة",
  "billing.doc.paidStamp": "مدفوعة",
  "billing.doc.voidStamp": "ملغاة",
  "billing.doc.accepted": "مقبول",
  "billing.doc.project": "المشروع",
  "billing.doc.askDetails": "اطلب منا تفاصيل الحساب.",
  "billing.doc.instapay": "إنستاباي",
  "billing.doc.vodafone": "فودافون كاش",
  "billing.doc.bank": "تحويل بنكي",
  "billing.doc.reference": "اكتب رقم المستند كمرجع للتحويل.",
  "billing.doc.thanks": "شكراً لتعاملكم معنا.",
  "billing.public.title": "العرض {number}",
  "billing.public.for": "مُعد لـ{client}",
  "billing.public.acceptTitle": "قبول العرض",
  "billing.public.name": "اسمك",
  "billing.public.email": "بريدك الإلكتروني",
  "billing.public.agree": "أوافق على هذا العرض وشروطه.",
  "billing.public.accept": "قبول العرض",
  "billing.public.decline": "رفض العرض",
  "billing.public.declineTitle": "رفض العرض؟",
  "billing.public.declineReason": "أخبرنا بالسبب (اختياري)",
  "billing.public.declined": "رفضت هذا العرض في {date}. شكراً لإبلاغنا.",
  "billing.public.accepted": "قبله {name} في {date}. شكراً لك!",
  "billing.public.next": "سنرسل إليك طلب الدفع الأول قريباً.",
  "billing.public.expired": "انتهت صلاحية هذا العرض في {date}. تواصل معنا للحصول على عرض محدّث.",
  "billing.public.invalid": "هذا الرابط غير صالح",
  "billing.public.invalidBody": "اطلب منا رابطاً جديداً للعرض.",
  "billing.public.validUntil": "صالح حتى {date}",
  "billing.public.total": "الإجمالي",
  "billing.public.nameMissing": "أدخل اسمك.",
  "billing.public.emailMissing": "أدخل بريداً إلكترونياً صحيحاً.",
  "billing.public.agreeMissing": "ضع علامة في المربع للقبول.",
  "billing.public.switch": "English",
  "billing.public.recorded": "يُسجَّل قبولك مع وقته وجهازك.",
  "billing.public.questions": "لديك أسئلة؟ راسلنا على {email}",
  "billing.public.loading": "جارٍ تحميل العرض",
  "billing.reports.title": "تقارير الفواتير",
  "billing.reports.subtitle": "ما يدين به العملاء وما تم تحصيله ومصادر الإيراد، لكل عملة على حدة.",
  "billing.reports.loadError": "تعذّر تحميل التقارير.",
  "billing.reports.currency": "العملة",
  "billing.ageing.title": "المستحقات حسب العمر",
  "billing.ageing.hint": "الأرصدة المفتوحة حسب أيام التأخر عن الاستحقاق.",
  "billing.ageing.current": "لم تستحق بعد",
  "billing.ageing.range": "من {from} إلى {to} يوماً",
  "billing.ageing.over": "أكثر من {days} يوماً",
  "billing.ageing.byClient": "حسب العميل",
  "billing.ageing.empty": "لا أرصدة مفتوحة: كل ما صدر مدفوع.",
  "billing.ageing.total": "إجمالي المفتوح",
  "billing.cash.title": "النقد المحصّل",
  "billing.cash.hint": "المال المستلم شهرياً. استخدام رصيد العميل ليس مالاً جديداً.",
  "billing.cash.empty": "لا مدفوعات في آخر اثني عشر شهراً.",
  "billing.cash.total": "اثنا عشر شهراً",
  "billing.chart.bar": "{month}: {amount}",
  "billing.revenue.title": "الإيراد",
  "billing.revenue.hint": "المفوتر قبل الضريبة وبعد خصم الإشعارات الدائنة.",
  "billing.revenue.byClient": "حسب العميل",
  "billing.revenue.byService": "حسب الخدمة",
  "billing.revenue.period": "الفترة",
  "billing.revenue.period.90": "٩٠ يوماً",
  "billing.revenue.period.365": "١٢ شهراً",
  "billing.revenue.period.year": "هذا العام",
  "billing.revenue.empty": "لا إيراد مفوتر في هذه الفترة.",
  "billing.revenue.other": "أخرى",
  "billing.projectCard.title": "الفواتير",
  "billing.projectCard.billed": "المفوتر",
  "billing.projectCard.paid": "المدفوع",
  "billing.projectCard.outstanding": "المستحق",
  "billing.projectCard.empty": "لا عروض أو فواتير لهذا المشروع بعد.",
  "billing.projectCard.viewAll": "فتح الفواتير",
  "billing.projectCard.documents": "المستندات",
  "billing.projectCard.loadError": "تعذّر تحميل فواتير هذا المشروع.",
  "billing.legal.title": "فواتير مبدئية وليست ضريبية",
  "billing.legal.body": "يُصدر 404 OS العروض والفواتير المبدئية وطلبات الدفع. تُصدر الفاتورة الضريبية الرسمية لعملاء مصر عبر منظومة الفاتورة الإلكترونية لدى المحاسب.",
  "billing.tab.expenses": "المصروفات",
  "billing.kpi.expenses": "المصروف هذا الشهر",
  "billing.newExpense": "مصروف جديد",
  "billing.empty.expenses.title": "لا توجد مصروفات بعد",
  "billing.empty.expenses.body": "سجّل الاشتراكات والإعلانات والمستقلين وتكاليف المكتب. اربط المصروف بمشروع لترى ربحه.",
  "billing.expenseCategory.software": "برمجيات واشتراكات",
  "billing.expenseCategory.advertising": "إعلانات",
  "billing.expenseCategory.freelancers": "مستقلون",
  "billing.expenseCategory.salaries": "رواتب",
  "billing.expenseCategory.office": "المكتب",
  "billing.expenseCategory.equipment": "معدات",
  "billing.expenseCategory.travel": "سفر وتنقلات",
  "billing.expenseCategory.fees": "رسوم",
  "billing.expenseCategory.other": "أخرى",
  "billing.expenses.search": "ابحث بالوصف أو المورد",
  "billing.expenses.category": "الفئة",
  "billing.expenses.allCategories": "كل الفئات",
  "billing.expenses.project": "المشروع",
  "billing.expenses.allProjects": "كل المشاريع",
  "billing.expenses.col.expense": "المصروف",
  "billing.expenses.col.category": "الفئة",
  "billing.expenses.col.project": "المشروع",
  "billing.expenses.receipt.open": "فتح الإيصال",
  "billing.expenses.edit": "تعديل {name}",
  "billing.expenses.delete": "حذف {name}",
  "billing.expenses.deleteTitle": "حذف هذا المصروف؟",
  "billing.expenses.deleteBody": "سيُحذف «{name}» وإيصاله. لا يمكن التراجع عن ذلك.",
  "billing.expenses.deleteConfirm": "حذف المصروف",
  "billing.expenses.deleting": "جارٍ الحذف…",
  "billing.expenses.deleted": "حُذف المصروف",
  "billing.expenseDialog.newTitle": "مصروف جديد",
  "billing.expenseDialog.editTitle": "تعديل المصروف",
  "billing.expenseDialog.description": "سجّل ما أنفقته الوكالة، بالعملة التي دُفع بها.",
  "billing.expenseDialog.category": "الفئة",
  "billing.expenseDialog.what": "مقابل ماذا؟",
  "billing.expenseDialog.whatPlaceholder": "Figma — ٣ مقاعد لشهر أكتوبر",
  "billing.expenseDialog.vendor": "المورد (اختياري)",
  "billing.expenseDialog.vendorPlaceholder": "لمن دُفع المبلغ",
  "billing.expenseDialog.amount": "المبلغ",
  "billing.expenseDialog.currency": "العملة",
  "billing.expenseDialog.spentOn": "التاريخ",
  "billing.expenseDialog.project": "المشروع (اختياري)",
  "billing.expenseDialog.projectHint": "يُحتسب من ربح المشروع.",
  "billing.expenseDialog.notes": "ملاحظات (اختياري)",
  "billing.expenseDialog.receipt": "الإيصال (اختياري)",
  "billing.expenseDialog.receiptHint": "PDF أو PNG أو JPEG أو WebP بحد أقصى ١٠ ميجابايت.",
  "billing.expenseDialog.receiptCurrent": "المرفق: {name}",
  "billing.expenseDialog.receiptReplace": "اختيار ملف جديد يستبدله.",
  "billing.expenseDialog.receiptRemove": "إزالة الإيصال",
  "billing.expenseDialog.receiptRemoved": "أُزيل الإيصال",
  "billing.expenseDialog.receiptFailed": "حُفظ المصروف لكن لم يُرفع الإيصال. حاول إرفاقه مرة أخرى.",
  "billing.expenseDialog.create": "تسجيل المصروف",
  "billing.expenseDialog.save": "حفظ التغييرات",
  "billing.expenseDialog.saving": "جارٍ الحفظ…",
  "billing.expenseDialog.created": "سُجّل المصروف",
  "billing.expenseDialog.saved": "حُفظ المصروف",
  "billing.expenseDialog.errors.what": "اكتب مقابل ماذا دُفع المبلغ.",
  "billing.expenseDialog.errors.amount": "أدخل مبلغاً أكبر من صفر.",
  "billing.expenseDialog.errors.spentOn": "اختر يوم الدفع.",
  "billing.error.EXPENSE_NOT_FOUND": "هذا المصروف لم يعد موجوداً.",
  "billing.error.RECEIPT_NOT_FOUND": "لا يوجد إيصال مرفق بهذا المصروف.",
  "billing.projectCard.expenses": "المصروف",
  "billing.projectCard.profit": "الربح",
  "billing.projectCard.profitHint": "المدفوع ناقص المصروف، لكل عملة.",
  "billing.tab.contracts": "العقود",
  "billing.contracts.subtitle": "مستندات قانونية تُحفظ على العميل. يعلّم الفريق متى خرجت ومتى عادت موقّعة.",
  "billing.newContract": "عقد جديد",
  "billing.empty.contracts.title": "لا توجد عقود بعد",
  "billing.empty.contracts.body": "ارفع عقد Word أو PDF على عميل، ثم علّمه مُرسلاً وموقّعاً.",
  "billing.filter.signed": "موقّعة",
  "billing.contractStatus.draft": "مسودة",
  "billing.contractStatus.sent": "مُرسل",
  "billing.contractStatus.signed": "موقّع",
  "billing.contractStatus.declined": "مرفوض",
  "billing.contract.new": "عقد جديد",
  "billing.contract.edit": "تعديل العقد",
  "billing.contract.file": "ملف العقد",
  "billing.contract.fileHint": "PDF أو PNG أو JPEG أو WebP، حتى 10 ميجابايت.",
  "billing.contract.fileRequired": "أرفق ملف العقد.",
  "billing.contract.open": "فتح الملف",
  "billing.contract.openSigned": "فتح النسخة الموقّعة",
  "billing.contract.signedFile": "النسخة الموقّعة",
  "billing.contract.signedHint": "مسح ضوئي اختياري للصفحات الموقّعة.",
  "billing.contract.markSent": "تعليم كمرسل",
  "billing.contract.markSigned": "تعليم كموقّع",
  "billing.contract.markDeclined": "تعليم كمرفوض",
  "billing.contract.send.title": "تعليم هذا العقد كمرسل؟",
  "billing.contract.send.body": "يأخذ رقماً ولا يعود الملف قابلاً للتغيير.",
  "billing.contract.sign.title": "تعليم هذا العقد كموقّع؟",
  "billing.contract.sign.body": "أرفق المسح الموقّع إن وُجد. يمكن تعليمه موقّعاً بدونه.",
  "billing.contract.decline.title": "تعليم هذا العقد كمرفوض؟",
  "billing.contract.decline.body": "العميل لم يوقّع. لا يمكن التراجع.",
  "billing.contract.sent": "عُلّم العقد {number} كمرسل.",
  "billing.contract.signed": "عُلّم العقد كموقّع.",
  "billing.contract.declined": "عُلّم العقد كمرفوض.",
  "billing.contract.created": "حُفظ العقد.",
  "billing.contract.fileOnly": "ملف",
  "billing.quote.mode.label": "طريقة كتابة هذا العرض",
  "billing.quote.mode.build": "البناء في 404 OS",
  "billing.quote.mode.file": "إرفاق ملف",
  "billing.quote.mode.fileHint": "العميل والعنوان مطلوبان. البنود وخطة الدفع ليستا كذلك.",
  "billing.quote.file": "ملف العرض",
  "billing.quote.fileRequired": "أرفق ملف العرض.",
  "billing.quote.accept": "تعليم كمقبول",
  "billing.quote.accept.title": "تعليم هذا العرض كمقبول؟",
  "billing.quote.accept.body": "قبل العميل خارج النظام. هذا لا يُنشئ فواتير ولا مشروعاً.",
  "billing.quote.accepted": "عُلّم العرض كمقبول.",
  "billing.quote.fileAttached": "الملف مرفق"
}
